/* eslint-disable react-hooks/rules-of-hooks */
import { useToken } from 'hooks/Tokens'
import { usePool } from 'hooks/usePools'
import { useMemo } from 'react'
import { PositionDetails } from 'types/position'
import { unwrappedToken } from 'utils/wrappedCurrency'

const usePositionItem = (positionDetails: PositionDetails) => {
  const {
    token0: token0Address,
    token1: token1Address,
    fee: feeAmount,
    liquidity,
    tickLower,
    tickUpper,
  } = positionDetails

  const token0 = useToken(token0Address)
  const token1 = useToken(token1Address)
  const currency0 = token0 ? unwrappedToken(token0) : undefined
  const currency1 = token1 ? unwrappedToken(token1) : undefined

  // construct Position from details returned
  const [, pool] = usePool(currency0 ?? undefined, currency1 ?? undefined, feeAmount)

  // check if price is within range
  const outOfRange: boolean = pool ? pool.tickCurrent < tickLower || pool.tickCurrent >= tickUpper : false

  const removed = liquidity?.eq(0)
  return {
    status: removed ? 3 : !outOfRange ? 1 : 2,
  }
}
export const usePositionList = (positions: PositionDetails[]) => {
  const positionsWithStatus = positions.map((position) => ({
    ...position,
    status: usePositionItem(position).status,
  }))

  const sortedPositions = useMemo(() => {
    return positionsWithStatus.sort((prev, cur) => {
      return prev.status - cur.status
    })
  }, [positionsWithStatus])

  return sortedPositions
}
